<section class="w3l-form-25">
    <div class="form-inner-cont">
        <div class="w3l-form-25">
            <h1>Items (Drugs) Master Data</h1>
            <p>Enter Items Details Master Data below to stay updated </p>
        </div>
    </div>
</section>

<div id="w3l-appointment">
    <section class="appointment-section section-gap">

        <div class="wrapper">
            <div class="d-grid doctor-appointment">
                <div class="appointment-form">
                    <form action="#" method="post">
                        <div class="fields-grid">
                            <div class="styled-input">
                                <label>Item Code</label>
                                <div class="appointment-form-field">
                                    <span class="fa fa-search" aria-hidden="true" (click)="openDialog()" style="cursor: grab;"></span>
                                    <input type="text" name="ItemCode" placeholder="Item Code" required=""
                                        style="width: 30%;"  [(ngModel)]="itCode" (change)="retriveItems()"maxlength="15ch">

                                </div>
                            </div>
                            <div class="styled-input">
                                <label>Item Name</label>
                                <div class="appointment-form-field">
                                    <span class="fa fa-edit" aria-hidden="true"></span>
                                    <input type="text" name="Itemname" placeholder="Item Name" required="" [(ngModel)]="itTName" maxlength="50ch" >
                                </div>
                            </div>
                            <div class="styled-input">
                                <label>Arabic Name</label>
                                <div class="appointment-form-field">
                                    <span class="fa fa-file-powerpoint-o" aria-hidden="true"></span>
                                    <input type="text" name="TradeName" placeholder="Arabic Name" required="" [(ngModel)]="itAName" maxlength="50ch">
                                </div>
                            </div>
                            <div class="styled-input">
                                <label>Classification</label>
                                <div class="appointment-form-field">
                                    <span class="fa fa-sitemap" aria-hidden="true"></span>
                                  <select id="classification" name="classification" required="" [(ngModel)]="itClass" [value]="itClass">
                                     <option value="{{cls.clasCode}}" *ngFor="let cls of classificationList; let i = index">{{cls.clasName}}</option>

                                    </select>
                                </div>
                            </div>
                            <div class="styled-input">
                                <label>Cost Price</label>

                                <label>                      Sales Price</label>
                                <div class="appointment-form-field">
                                    <span class="fa fa-tag" aria-hidden="true"></span>
                                    <input type="text" name="Cost" placeholder="00.00" required="" [(ngModel)]="iTPurchasis"style="width: 25%;">
                                    <label>   </label>
                                    <span class="fa fa-tags" aria-hidden="true"></span>
                                    <input type="text" name="Sales" placeholder="00.00" required=""  [(ngModel)]="iTMedical" style="width: 25%;">
                                </div>
                            </div>
                            <div class="styled-input">
                                <label>Unit of Measure </label>
                                <div class="appointment-form-field">
                                    <span class="fa fa-cubes" aria-hidden="true"></span>
                                    <select id="department" name="department" required="" [(ngModel)]="itUnit" [value]="itUnit">
                                        <option value="{{unit.unCode}}" *ngFor="let unit of unitsList; let i = index">{{unit.unName}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="styled-input">
                                <label>Pharma. Group </label>
                                <div class="appointment-form-field">
                                    <span class="fa fa-building-o" aria-hidden="true"></span>
                                    <select id="pharmgroups" name="pharmgroups" required=""  [(ngModel)]="iTGrouping" [value]="iTGrouping">
                                      <option value="{{grs.serial}}"  *ngFor="let grs of pharmGroupList; let i = index">{{grs.pharmacyGroupName}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="styled-input">
                                <label>Store Requirements</label>
                                <BR>
                                <BR>
                                <div class="appointment-form-field">
                                    <span class="fa fa-university" aria-hidden="true" style="height: 200%;"></span>
                                    <textarea rows="5" cols="60" name="description" class="appointment-form-field"
                                        style="height: 200%;"  [(ngModel)]="iTStore" maxlength="150ch"> Enter details here... </textarea><br>
                                </div>
                            </div>


                            <div class="clear"> </div>
                        </div>
                    </form>
                </div>

                <div class="registerimg">
                    <img src="assets/images/Items.jpg" alt="" />
                </div>
            </div>

        </div>
    </section>
    <section>
    <div class="appointment-form" style="text-align: center;">
      <button type="button" class="theme-button btn" name="submit" (click)="submitItems()">Submit</button>
      <button type="button" class="theme-button btn" name="Delete"(click)="mesgDelete()">Delete</button>
      <button type="button" class="theme-button btn" name="New" (click)="NewData()">New</button>
      <a href="Home">
          <button type="button" class="theme-button btn"    name="Back">Home</button>
      </a>
    </div>
  </section>
    <BR>
</div>
